import {connect} from "react-redux";
import {useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {getAllVerifyResponse} from "../store/logIn";
import {FormControl, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select} from "@mui/material";
import Header from "../blocks/header";
import Dashboard from "../blocks/dashboard";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";
import Box from "@mui/material/Box";
import Copyright from "../blocks/copyright";
import EditIcon from '@mui/icons-material/Edit';
import ReactPaginate from "react-paginate";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import Button from "@mui/material/Button";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import {toast} from "react-toastify";
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import {getAllOrders, messageReset} from "../store/orders";

function Orders(props) {
    const is_main = JSON.parse(localStorage.getItem('is_main'));
    const navigate = useNavigate()
    const [orders, setOrders] = useState([])
    const [filteredOrders, setFilteredOrders] = useState(false)
    const [search, setSearch] = useState('')
    const [scan, setScan] = useState(1)

    useEffect(() => {
        if (props.message === 'deleted') {
            toast.success("Muvaffaqiyatli saqlandi!", {theme: 'colored'})
            props.messageReset()
        } else if (props.message === 'error') {
            toast.error("Xatolik!", {theme: 'colored'})
            props.messageReset()
        } else if (props.message === true) {
            toast.success("Muvaffaqiyatli saqlandi!", {theme: 'colored'})
            props.messageReset()
        }
    }, [props.message])


    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token !== 'undefined') {
            const data = {
                "token": JSON.parse(token)
            }
            props.getAllVerifyResponse(data)
        }
        props.getAllOrders()
    }, [])


    useEffect(() => {
        if (props.verify === false) {
            navigate("/login/");
        }
        if (props.orders){
            setOrders(props.orders)
        }
    }, [props])
    // Pagination
    var arr = []
    const pageItems = filteredOrders ? filteredOrders : orders ? orders : arr
    const [itemsPerPage, setItemsPerPage] = useState(10)

    const [itemOffset, setItemOffset] = useState(0);

    const endOffset = itemOffset + itemsPerPage;
    const currentItems = pageItems.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(pageItems.length / itemsPerPage);

    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % pageItems.length;
        setItemOffset(newOffset);
    };

    if (pageCount !== 0 && currentItems.length === 0) {
        let li_lenght = document.querySelectorAll('.pagination ul li').length
        document.querySelectorAll('.pagination ul li')[li_lenght - 2].previousSibling.className = 'selected'
        const data = {"selected": pageCount - 1}
        handlePageClick(data)
    }

    function toEdit(data) {
        navigate('/orders/' + data.id)
    }

    useEffect(() => {
        let filterOrders = search ? true : false
        if (scan == 'confirmed_no') {
            filterOrders = filterOrders ? props.orders.filter(item => (item['code'].toLowerCase().search(search.toLowerCase()) !== -1)).filter(item => item['confirmed'] == scan)
                : props.orders.filter(item => item['confirmed'] == scan)
            const arrayUniqueByKey = [...new Map(filterOrders.map(item =>
                [item['id'], item])).values()];
            setFilteredOrders([...arrayUniqueByKey])
        }
        if (scan == 'confirmed_yes') {
            filterOrders = filterOrders ? props.orders.filter(item => (item['code'].toLowerCase().search(search.toLowerCase()) !== -1)).filter(item => item['confirmed'] == scan)
                : props.orders.filter(item => item['confirmed'] == scan)
            const arrayUniqueByKey = [...new Map(filterOrders.map(item =>
                [item['id'], item])).values()];
            setFilteredOrders([...arrayUniqueByKey])
        }
        if (scan == 'confirmed_check') {
            filterOrders = filterOrders ? props.orders.filter(item => (item['code'].toLowerCase().search(search.toLowerCase()) !== -1)).filter(item => item['confirmed'] == scan)
                : props.orders.filter(item => item['confirmed'] == scan)
            const arrayUniqueByKey = [...new Map(filterOrders.map(item =>
                [item['id'], item])).values()];
            setFilteredOrders([...arrayUniqueByKey])
        }
        if (scan == '1' && !search) {
            setFilteredOrders(false)
        } else if (scan == '1' && search){
            filterOrders = props.orders.filter(item => (item['code'].toLowerCase().search(search.toLowerCase()) !== -1))
            const arrayUniqueByKey = [...new Map(filterOrders.map(item =>
                [item['id'], item])).values()];
            setFilteredOrders([...arrayUniqueByKey])
        }
    }, [scan, search, props.orders]);

    function ToFilter(e) {
        e.preventDefault()
        if (!e.target.value && scan == '1') {
            setFilteredOrders(false)
        } else {
            let filterOrders = scan !== 1 ? true : false
            if (e.target.value && filterOrders) {
                const search_word = e.target.value
                filterOrders = filterOrders ? props.orders.filter(item =>
                        (item['code'].toLowerCase().search(search_word.toLowerCase()) !== -1)).filter(item => item.confirmed == scan)
                    : props.orders.filter(item =>
                        (item['code'].toLowerCase().search(search_word.toLowerCase()) !== -1))
                const arrayUniqueByKey = [...new Map(filterOrders.map(item =>
                    [item['id'], item])).values()];
                setFilteredOrders([...arrayUniqueByKey])
            } else if (e.target.value) {
                const search_word = e.target.value
                filterOrders = props.orders.filter(item => (item['code'].toLowerCase().search(search_word.toLowerCase()) !== -1))
                const arrayUniqueByKey = [...new Map(filterOrders.map(item =>
                    [item['id'], item])).values()];
                setFilteredOrders([...arrayUniqueByKey])
            }
        }
    }


    return <div>
        <div className={'page worker-page serial_numbers'}>
            <Header/>
            <Dashboard/>
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    height: '100vh',
                    overflow: 'auto',
                }}>
                <Toolbar/>
                <div className={'main'}>
                    <div className={'header-page'}>
                        <h2 className={'page-title'}>{"Buyurtmalar"}</h2>
                    </div>
                    <div className={'filter-block'}>
                        <form onChange={ToFilter}>
                            <p><span>{"Izlash"}:</span>
                                <FormControl variant="outlined">
                                    <InputLabel htmlFor="outlined-adornment-password">{"Izlash"}</InputLabel>
                                    <OutlinedInput
                                        id="outlined-adornment-password"
                                        type={'text'}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle search"
                                                    edge="end"
                                                    value={search}
                                                    onChange={(event) => {
                                                        setSearch(event.target.value)
                                                    }}
                                                >
                                                    <SearchIcon/>
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                        label={"Izlash"}
                                    />
                                </FormControl>
                            </p>
                            <p><span>{"Holati"}:</span>
                                <Box sx={{minWidth: 200}}>
                                    <FormControl fullWidth>
                                        <InputLabel
                                            id="demo-simple-select-label">{"Filter"}</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={scan}
                                            label={"Filter"}
                                            onChange={(e) => {
                                                setScan(e.target.value)
                                            }}
                                        >
                                            <MenuItem value={1}>{"Barchasi"}</MenuItem>
                                            <MenuItem value={'confirmed_no'}>{"Tasdiqlanmagan"}</MenuItem>
                                            <MenuItem value={'confirmed_check'}>{"Tekshirilmoqda"}</MenuItem>
                                            <MenuItem value={'confirmed_yes'}>{"Tasdiqlangan"}</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Box></p>
                        </form>
                    </div>
                    {currentItems.length ? <table className="table table-hover table-responsive ">
                        <thead>
                        <tr>
                            <th scope="col">{"Mijoz kodi"}</th>
                            <th scope="col">{"Partiya raqami"}</th>
                            <th scope="col">{"Buyurtma holati"}</th>
                            <th scope="col">{""}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {currentItems.length ? currentItems.map((item, index) => <tr key={index}>
                                <th scope="row">{item['code']}</th>
                                <td>{item['serial_number']}</td>
                                <td>
                                    {item['confirmed'] === "confirmed_no" && "Tasdiqlanmagan"}
                                    {item['confirmed'] === "confirmed_check" && "Tekshirilmoqda"}
                                    {item['confirmed'] === "confirmed_yes" && "Tasdiqlangan"}
                                </td>
                                <td>
                                    {item['confirmed'] === "confirmed_check" ?
                                        <Button variant="contained" title={"O'zgartirish"} color={"info"}
                                                endIcon={<EditIcon/>}
                                                onClick={()=>toEdit(item)}/>
                                    : ''}
                                </td>
                            </tr>)
                            :
                            ''
                        }
                        </tbody>
                    </table> : ''}
                    {pageCount > 1 ? <div className={'pagination'}>
                        <ReactPaginate
                            breakLabel="..."
                            nextLabel={<KeyboardArrowRightIcon/>}
                            onPageChange={handlePageClick}
                            pageRangeDisplayed={5}
                            pageCount={pageCount}
                            previousLabel={<KeyboardArrowLeftIcon/>}
                            renderOnZeroPageCount={null}
                        />
                    </div> : ''}
                </div>
                <Copyright/>
            </Box>
        </div>
    </div>
}

export default connect(props => props.orders, {getAllOrders, getAllVerifyResponse, messageReset})(Orders)